import shortlist from 'vx/modules/shortlist'
import app from 'vx/modules/app'
import authentication from 'vx/modules/authentication'
import businessintelligence from 'vx/modules/businessintelligence'
import user from 'vx/modules/user'
import talent from 'vx/modules/talent'
import admin from 'vx/modules/admin'
import intern from 'vx/modules/intern'
import client from 'vx/modules/client'
import manager from 'vx/modules/manager'
import location from 'vx/modules/location'
import settings from 'vx/modules/settings'
import opportunity from 'vx/modules/opportunity'
import category from 'vx/modules/category'
import booking from 'vx/modules/booking'
import payment from 'vx/modules/payment'
import billboard from 'vx/modules/billboard'
import dashboard from 'vx/modules/dashboard'
import tag from 'vx/modules/tag'
import report from 'vx/modules/report'
import system from 'vx/modules/system'
import calendar from 'vx/modules/calendar'
import message from 'vx/modules/message/message'
import notifications from 'vx/modules/notifications/notifications'
import notification from 'vx/modules/notification'
import filtering from 'vx/modules/filtering'
import tags from 'vx/modules/filtering/tags'
import editing from 'vx/modules/editing'
import region from 'vx/modules/region'
import contract from 'vx/modules/contract'
import clientConfig from 'vx/modules/clientConfig'

/**
 * Build modules used within the Pickstar application.
 *
 * These are imported into the Vuex store.
 */
export default {
  app,
  authentication,
  businessintelligence,
  user,
  talent,
  admin,
  intern,
  client,
  manager,
  location,
  settings,
  opportunity,
  category,
  booking,
  shortlist,
  payment,
  billboard,
  dashboard,
  tag,
  report,
  system,
  calendar,
  notification,
  filtering,
  message,
  notifications,
  tags,
  editing,
  region,
  contract,
  clientConfig
}
